import {
  AddRechargeActivity,
  GetRechargeActivity
} from '@/api/recharge'
export default {
  state: {

  },
  actions: {
    AddRechargeActivity ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        AddRechargeActivity(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    GetRechargeActivity ({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        GetRechargeActivity(payload).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    }
  },
  getters: {

  },
  mutations: {

  }
}
